var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaypalLogotypeGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 55,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.583 43.183 8.13 39.6l-1.216-.03H1.107l4.035-26.44a.352.352 0 0 1 .113-.207.323.323 0 0 1 .215-.082h9.79c3.25 0 5.492.7 6.663 2.079.55.647.899 1.323 1.068 2.068.177.78.18 1.713.007 2.851l-.012.084v.729l.549.321c.462.254.83.544 1.111.876.47.553.773 1.256.902 2.09.132.858.089 1.878-.129 3.033-.25 1.33-.655 2.487-1.202 3.434a6.98 6.98 0 0 1-1.905 2.157c-.726.533-1.59.937-2.565 1.196-.945.255-2.023.383-3.206.383h-.762c-.545 0-1.074.203-1.49.566a2.406 2.406 0 0 0-.776 1.433l-.057.322-.964 6.316-.044.231c-.012.074-.032.11-.06.135a.158.158 0 0 1-.101.038H7.583Z",
    fill: "#00ff40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.054 20.006c-.03.193-.063.39-.1.594-1.291 6.85-5.708 9.216-11.349 9.216H9.733c-.69 0-1.271.518-1.379 1.222l-1.47 9.638-.417 2.732c-.07.462.275.878.726.878h5.094c.603 0 1.115-.453 1.21-1.068l.05-.267.96-6.29.061-.346c.094-.617.608-1.07 1.21-1.07h.763c4.935 0 8.799-2.07 9.928-8.064.472-2.503.228-4.594-1.02-6.064a4.896 4.896 0 0 0-1.395-1.11Z",
    fill: "#0c5f38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.703 19.45a9.883 9.883 0 0 0-1.255-.288c-.774-.13-1.623-.19-2.532-.19h-7.673c-.189 0-.368.043-.529.123a1.261 1.261 0 0 0-.68.946L8.4 30.726l-.047.312c.108-.704.69-1.221 1.379-1.221h2.872c5.641 0 10.058-2.368 11.349-9.217.038-.203.07-.4.1-.593a6.76 6.76 0 0 0-1.061-.463 9.349 9.349 0 0 0-.29-.094Z",
    fill: "#35FF61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.034 20.041c.063-.424.326-.77.68-.945.162-.08.34-.124.53-.124h7.672c.91 0 1.758.062 2.532.191a9.812 9.812 0 0 1 1.546.38c.38.131.735.286 1.061.464.384-2.532-.003-4.256-1.327-5.816-1.46-1.719-4.096-2.454-7.468-2.454H5.47c-.688 0-1.276.518-1.382 1.222L.01 39.67c-.08.529.314 1.005.83 1.005h6.044l1.517-9.95 1.633-10.685Z",
    fill: "#00ff40"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h27v55H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypalLogotypeGreen);
export default __webpack_public_path__ + "static/media/paypal-logotype-green.f8e92468dcf47d53a21af5411f46e87b.svg";
export { ForwardRef as ReactComponent };